import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { SearchSchema } from "./-schema";

export const Route = createFileRoute(
  "/_staff/certification/_list/settings/issuing-organization/",
)({
  validateSearch: zodValidator(SearchSchema),
});
